export default {
  className: 'happyBeanRecords',
  fields: [
    'user',
    'access',
    'number',
    'revenue',
    'realTimeBalance'
  ],
  search: [
    'user',
    'access'
  ],
  action: false
}
